import { toast } from "react-toastify";
import { string } from "yup";
export const errorHandler = (err, message) => {
    if (err) toast.error(err);
    else toast.error(message);
}


export const customErrorHandler = (error) => {
    let errorMessage = ''
    if (error?.response?.data?.message) {
        errorMessage = error?.response?.data?.message
    } else if (error?.response?.data?.errMessage) {
        errorMessage = error?.response?.data?.errMessage
    } else {
        errorMessage = "something went wrong"
    }
    return toTitleCase(errorMessage)
}



export function toTitleCase(str) {
  if(!str){
    return
  }
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}

export function formatTransactionType(type) {
  if (!type) return type;
  if(typeof(type) !== String){
  
  // Replace all hyphens with spaces
  let formatted = type.replace(/-/g, ' ');
  
  // Capitalize first letter of each word
  formatted = formatted.split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  
  return formatted;
  }
}


export const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    // Extract year, month, day, and time dynamically
    const year = date.getFullYear() ; // Adjust the year dynamically
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

    // Combine all into the desired format
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};